















import {
  Vue, Component, Prop, Watch, Mixins, Emit,
} from 'vue-property-decorator'
import dayjs from 'dayjs'
import {
  update, field, collection, get, query, where, set, add,
} from 'typesaurus'
import {
  getModule,
} from 'vuex-module-decorators'
import { VueEditor } from 'vue2-editor'
import { InfoBoardType } from '../types'
import { db } from '../firebase/init'
import MainMixin from '../mixins/MainMixin'
import EventBus from '../event-bus'
import CardList from '../components/layout/CardList.vue'
import InfoBoardsStore from '../store/modules/infoBoards'

const infoBoard = collection<InfoBoardType>('infoBoards')

@Component({
  components: {
    CardList,
    VueEditor,
  },
})

export default class InfoBoards<T extends Vue> extends Mixins(MainMixin) {
  tabs = [{ title: 'Daily', value: 'daily', name: `Daily Info (${this.weekday})` }, { title: 'FoH', value: 'foh', name: 'Front Of House Info' }, { title: 'BoH', value: 'boh', name: 'Back of House Info' }, { title: 'Management', value: 'management', name: 'Management Info' }, { title: 'Handbook', value: 'handbook', name: 'Employee Handbook' }]

  weekdays = [{ text: 'Sunday', value: 0 }, { text: 'Monday', value: 1 }, { text: 'Tuesday', value: 2 }, { text: 'Wednesday', value: 3 }, { text: 'Thursday', value: 4 }, { text: 'Friday', value: 5 }, { text: 'Saturday', value: 6 }, { text: 'All Days', value: 7 }]

  activeBoard:string = ''

  get activeBoardData() {
    if (!this.activeBoard && this.activeTab !== 'daily') {
      return { id: null }
    } if (this.activeTab !== 'daily') {
      return this.allBoards.find((board:InfoBoardType) => board.id === this.activeBoard)
    }
    console.log('here!!!!!!')
    return this.dailyBoard
  }

  get weekday() {
    return dayjs().format('dddd')
  }

  activeText = ''

  loading = false

  showNewDialog = false

  isGroup = false

  newBoard:InfoBoardType = {
    name: '', description: '', location: '', category: '', text: '', updated: new Date(),
  }

  saveBoard() {
    this.loading = true
  }

  clearDialog() {
    this.newBoard = {
      name: '', description: '', text: '', category: '', updated: new Date(),
    }
  }

  InfoBoards:any = getModule(InfoBoardsStore)

  get allBoards() {
    return this.InfoBoards.allBoards
  }

  get activeTab() {
    if (this.$store.state.appStore && this.$store.state.appStore.activeTab) {
      return this.$store.state.appStore.activeTab
    } return null
  }

  get dailyBoard():any {
    const dailyBoards = this.allBoards.filter((board:InfoBoardType) => board.category === 'daily')
    const dayData = dailyBoards.find((board:InfoBoardType) => board.name === dayjs().format('dddd'))
    const locationData = dailyBoards.find((board:InfoBoardType) => board.name === 'All Days (Store)')
    const groupData = dailyBoards.find((board:InfoBoardType) => board.name === 'All Days (Group)')
    if (!locationData || !groupData || !dayData) {
      return ({
        name: dayjs().format('dddd'), text: '<h3>No Information</h3>', description: '', category: 'daily', updated: new Date(),
      })
    }
    const allText = `${locationData.text}${locationData.text ? '<br />' : ''}${groupData.text}${groupData.text ? '<br />' : ''}${dayData.text}`
    return ({
      name: dayjs().format('dddd'), text: allText, description: '', category: 'daily', updated: new Date(),
    })
  }

  @Watch('activeTab', { immediate: true })
  onTabChange(newTab:string) {
    console.log('runing tab change')
    console.log('all boards is: ', this.allBoards)
    if (newTab !== 'daily') {
      const boardList = this.allBoards.filter((board:InfoBoardType) => board.category === newTab)
      console.log('boardlist: ', boardList)
      if (boardList && boardList[0] && boardList[0].id) {
        this.activeBoard = boardList[0].id
        this.activeText = boardList[0].text
      } else this.activeBoard = ''
    } else {
      const boardList = this.allBoards
    }
  }

  async created() {
    if (!this.InfoBoards.bound) {
      await this.InfoBoards.store.dispatch('bindInfoBoards')
      this.InfoBoards.setBound()
    }
    const boardList = this.allBoards.filter((board:InfoBoardType) => board.category === 'daily')
    if (boardList && boardList[0] && boardList[0].id) {
      this.activeBoard = boardList[0].id
      this.activeText = boardList[0].text
    } else this.activeBoard = this.dailyBoard.id
  }
}

